// extracted by mini-css-extract-plugin
module.exports = {"Header":"LocationPriceListModal_Header__2rJrC","Description":"LocationPriceListModal_Description__10VM7","Table":"LocationPriceListModal_Table__25f4i"};